import { render } from "./coach-personalinfo.vue?vue&type=template&id=4674b3a0"
import script from "./coach-personalinfo.vue?vue&type=script&lang=js"
export * from "./coach-personalinfo.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__